import React from 'react';
import Page from "../../components/page/page";
import {Link} from 'react-router-dom';
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";
const pageNotFound = () => {
    return (
        <Page>
            <Header />
            <div id="pageNotFound">
            <p>
                صفحه ای با این مشخصات پیدا نشد !<br />
                <Link to='/'>خانه</Link>
            </p>
            </div>
            <Footer />
        </Page>
    );
};

export default pageNotFound;